import i18n from '@/locales/i18n'

const columns = [
    {
        title: i18n.t('userList.name'),
        dataIndex: "name",
        width: "120px",
        align: "center"
    },
    {
        title: i18n.t('userList.contactNumber'),
        dataIndex: "mobile",
        width: "120px",
        align: "center"
    }
    // {   
    //     title: "用户ID",
    //     dataIndex: "id",
    //     width: "60px",
    //     align: "center"
    // },
    // {   
    //     title: "公司ID",
    //     dataIndex: "companyId",
    //     width: "120px",
    //     align: "center"
    // },

    // {
    //     title: "头像",
    //     dataIndex: "avatar",
    //     width: "100px",
    //     align: "center"
    // },
    // {
    //     title: "创建时间",
    //     dataIndex: "createdTime",
    //     width: "120px",
    //     align: "center"
    // },
    // {
    //     title: "更新时间",
    //     dataIndex: "updatedTime",
    //     width: "120px",
    //     align: "center"
    // }
];


export {
    columns,
}